import React, {useEffect, useState} from 'react';
import {Button, FormControl, FormControlLabel, Grid, MenuItem, Select, Switch, Tab, Tabs} from '@material-ui/core'
import {
    BooleanInput,
    DateInput,
    FormDataConsumer,
    maxLength,
    minLength,
    NumberInput,
    regex,
    required,
    SelectInput,
    showNotification,
    TextInput,
    translate
} from 'react-admin';
import {schoolYears, showWarningNotify} from "../../components";
import axiosInstance from "../../api/axios";
import {compose} from "redux";
import {connect} from "react-redux";
import withStyles from '@material-ui/core/styles/withStyles';
import {GenderInput} from "../../components/Gender";
import {Redirect} from 'react-router-dom';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import cloneDeep from 'lodash/cloneDeep';
import {ReligionTypeInput} from "../../components/ReligionType";
import {NationTypeInput} from "../../components/NationType";
import {NationalityTypeInput} from "../../components/NationalityType";
import Address from "./Address";
import AddressGdtxHybrid from "./AddressGdtxHybrid";

const styles = {
    button: {
        margin: 1,
    },
    selectArray: {
        minWidth: '90%',
    },
    width90: {
        width: '90%',
    },
    label: {fontWeight: 'bold', fontSize: 16},
    cancelBtn: {
        marginLeft: 20
    },
    checkboxGroup: {
        "& > div ": {
            flexDirection: 'column',
        }
    },
    customCheckBox: {
        "& > div > label ": {
            width: '100%'
        }
    }
};

const DOI_TUONG_UU_TIEN_CHOICES = [
    {id: 'Không', name: 'Không'},
    {id: 'Thân nhân người có công', name: 'Thân nhân người có công'},
    {id: 'Hộ nghèo', name: 'Hộ nghèo'},
    {id: 'Hộ cận nghèo', name: 'Hộ cận nghèo'},
    {id: 'Dân tộc thiểu số', name: 'Dân tộc thiểu số'},
    {id: 'Khuyết tật', name: 'Khuyết tật'},
    {id: 'Mồ côi', name: 'Mồ côi'},
];

const requiredField = required('Bắt buộc');
const requiredMax50 = [requiredField, maxLength(50, 'Không quá 50 ký tự')];
const requiredPhone = [
    requiredField,
    maxLength(10, 'Không quá 10 ký tự'),
    minLength(10, 'Không ít hơn 10 ký tự'),
    regex(/^(\d+)$/, 'SĐT không hợp lệ')
];
const optionalPhone = [regex(/^(\d{10})$/, 'SĐT không hợp lệ')];

const requiredIf = source => (value, values, props) =>
    values && values[source] ? requiredField(value, values, props) : undefined;
const requiredMax50If = source => [requiredIf(source), maxLength(50, 'Không quá 50 ký tự')];
const requiredIdentifierIf = source => [requiredIf(source), regex(/^(\d{12})$/, 'Căn cước không hợp lệ')];
const requiredYobIf = source => [
    requiredIf(source),
    maxLength(4, 'Không quá 4 ký tự'),
    minLength(4, 'Không ít hơn 4 ký tự'),
    regex(/^(\d+)$/, 'Năm sinh không hợp lệ')
];

const toPhoneChoices = formData => [
    formData.customerPhone,
    formData.haveFatherInfo && formData.fatherPhone,
    formData.haveMotherInfo && formData.motherPhone,
    formData.haveGuardianInfo && formData.guardianPhone,
]
    .filter(Boolean)
    .map(phone => ({id: phone, name: phone}));

const getBooleanValue = (event, value) =>
    typeof value === 'undefined' ? !!(event && event.target && event.target.checked) : value;


const AdmissionFieldsGdtxHybrid = props => {
    const [values, setValues] = React.useState({
        isRedirect: false,
        refreshList: false,
        openWhiteList: false,
        units: [],
        selectedElectives: []
    });
    const {
        defaultValue,
        save,
        allProgramServices,
        programServices,
        setProgramServices,
        selectedElectives, setSelectedElectives,
        selectedGraduations, setSelectedGraduations,
        useCategory, categories,
        selectedCategory,
        setSelectedCategory,
        templateVersion,
    } = props;

    const [electives, setElectives] = useState([])

    const [phanLuong, setPhanLuong] = useState(false)

    const [tabIndex, setTabIndex] = React.useState(-1);

    useEffect(() => {
        if (!defaultValue.isRedirect) {
            setValues({...values})
        } else {
            setValues({isRedirect: true, refreshList: true});
        }
    }, [defaultValue.isRedirect]);

    useEffect(() => {
        if (defaultValue.ready) {
            setPhanLuong(!!defaultValue.phanLuong)
            if (templateVersion == 'CHUYEN') {
                setTabIndex(1)
            } else {
                setTabIndex(0)
                loadElectives();
            }

        }
    }, [defaultValue.ready]);

    const loadElectives = () => {
        axiosInstance.get(`/api/admissionSubjects/search/findBySchoolYearAndActive?schoolYearId=${schoolYears[0].id}`).then((rs) => {
            if (rs.data) {
                const content = rs.data.content
                if (templateVersion == 'GDTX_HYBRID') {
                    if (useCategory) {
                        if (defaultValue.categoryId) {
                            const arr1 = categories.filter(c => c.id == defaultValue.categoryId)
                            if (arr1.length > 0) {
                                const category = arr1[0]
                                setSelectedCategory(category)
                                const subjects = category.subjects
                                setElectives(subjects.filter(s => !s.forced))
                            }
                        }
                    } else {
                        const arr1 = content.filter(p => p.type === 'ELECTIVE')
                        setElectives(arr1)
                    }
                }
            }
        })
    }
    const handleChangeCategory = async (event) => {
        const itemValue = event.target.value
        const prev = selectedCategory.id
        if (prev != itemValue) {
            const category = categories.filter(c => c.id == itemValue)[0]
            if (category) {
                setSelectedCategory(category)
                const subjects = category.subjects
                setElectives(subjects)
                const forcedSubjects = subjects.filter(s => s.forced)
                const removeSubjectIds = []
                const newSelectedElectives = [...selectedElectives]
                for (let i = 0; i < selectedElectives.length; i++) {
                    const elective = selectedElectives[i]
                    if (elective.admissionSubjectId) {
                        removeSubjectIds.push(selectedElectives[i].admissionSubjectId)
                    }
                    if (i < forcedSubjects.length) {
                        const clone = cloneDeep(forcedSubjects[i])
                        clone.type = 'ELECTIVE'
                        clone.admissionSubjectId = itemValue
                        clone.displayIndex = i + 1
                        newSelectedElectives[i] = clone

                        const cloneGraduation = cloneDeep(forcedSubjects[i])
                        cloneGraduation.type = 'ELECTIVE'
                        cloneGraduation.admissionSubjectId = itemValue
                        cloneGraduation.forced = false
                    } else {
                        newSelectedElectives[i] = {
                            admissionSubjectId: '',
                            type: 'ELECTIVE',
                            displayIndex: i + 1
                        }
                    }
                }
                setSelectedElectives(newSelectedElectives)
            }
        }
    }

    const handleChangeElective = (event, index) => {
        const itemValue = event.target.value
        handleChangeElectiveByValue(itemValue, index, electives)
    }

    const handleChangeElectiveByValue = (itemValue, index, electives) => {
        const prev = selectedElectives[index]
        if (prev.admissionSubjectId != itemValue) {
            const idx1 = selectedElectives.findIndex(p => p.admissionSubjectId && p.admissionSubjectId === itemValue)
            if (idx1 >= 0) {
                showWarningNotify('Vui lòng đăng ký môn tự chọn khác nhau.')
                return
            }
            const chose = electives.filter(e => e.id == itemValue)[0]
            const clone = cloneDeep(chose)
            clone.type = 'ELECTIVE'
            clone.admissionSubjectId = itemValue
            clone.displayIndex = index + 1
            const newArr1 = [...selectedElectives]
            newArr1[index] = clone
            setSelectedElectives(newArr1)

        }
    }


    const handleChangeTab = (event, newValue) => {
        setTabIndex(newValue);
    };
    const handleChangePhanLuong = (checked) => {
        setPhanLuong(checked);
        props.onDirectChange('phanLuong', checked);
    };

    function cancel() {
        setValues({isRedirect: true, refreshList: false});
    }

    if (values.isRedirect) {
        return <Redirect to={'/admissions?refreshView=' + values.refreshList}/>;
    }
    return (
        <React.Fragment>
            <Grid item xs={12} sm={12}>
                <Tabs value={tabIndex} onChange={handleChangeTab} textColor="secondary"
                      indicatorColor="secondary"
                      aria-label="secondary  tabs example"
                      style={{
                          borderBottom: '1px solid #2979ff',
                      }}
                >
                    <Tab label="Tuyển sinh" style={{
                        border: '1px solid #2979ff',
                        marginRight: '1px',
                        display: 'flex'
                    }}/>
                    <Tab label="Lý lịch" style={{border: '1px solid #2979ff', marginRight: '1px'}}/>
                </Tabs>
            </Grid>

            {tabIndex === 0 &&
                <React.Fragment>
                    <Grid item xs={12} sm={12}>
                        <span style={styles.label}>A) Thông tin học sinh</span>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <NumberInput source="stt" label="resources.admissions.fields.stt"
                                     InputProps={{readOnly: true}}
                                     onChange={props.onChange('stt')}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="customerName" label="resources.admissions.fields.customerName" disabled/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="dob" label="resources.admissions.fields.dob" disabled/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <GenderInput source="gender" disabled/>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={phanLuong}
                                    onChange={(e) => handleChangePhanLuong(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Phân luồng"
                        />
                    </Grid>

                    {phanLuong ?
                        <>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="truongThi" label="resources.admissions.fields.truongThi"
                                           maxLength={150}
                                           required
                                           onChange={props.onChange('truongThi')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="sbd" label="resources.admissions.fields.sbd"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('sbd')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monVan" label="resources.admissions.fields.monVan"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monVan')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monToan" label="resources.admissions.fields.monToan"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monToan')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monAnh" label="resources.admissions.fields.monAnh"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monAnh')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="tongDiemThi" label="resources.admissions.fields.tongDiemThi"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('tongDiemThi')}/>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextInput source="diemUuTien" label="resources.admissions.fields.diemUuTien"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('diemUuTien')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="diemKhuyenKhich"
                                           label="resources.admissions.fields.diemKhuyenKhich"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('diemKhuyenKhich')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="tongDiem" label="resources.admissions.fields.tongDiem"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('tongDiem')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="diemNote" label="resources.admissions.fields.diemNote"
                                           maxLength={100}
                                           onChange={props.onChange('diemNote')}/>
                            </Grid>
                        </>
                        :
                        <>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monToan" label="resources.admissions.fields.monToan"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monToan')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monVan" label="resources.admissions.fields.monVan"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monVan')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monGdcd" label="resources.admissions.fields.monGdcd"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monGdcd')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monLy" label="resources.admissions.fields.monLy"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monLy')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monHoa" label="resources.admissions.fields.monHoa"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monHoa')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monSinh" label="resources.admissions.fields.monSinh"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monSinh')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monSu" label="resources.admissions.fields.monSu"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monSu')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monDia" label="resources.admissions.fields.monDia"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('monDia')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="tbcn" label="resources.admissions.fields.tbcn"
                                           maxLength={6}
                                           required
                                           onChange={props.onChange('tbcn')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="hocLuc" label="resources.admissions.fields.hocLuc"
                                           maxLength={50}
                                           required
                                           onChange={props.onChange('hocLuc')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="hanhKiem" label="resources.admissions.fields.hanhKiem"
                                           maxLength={50}
                                           required
                                           onChange={props.onChange('hanhKiem')}/>
                            </Grid>
                        </>
                    }
                    <Grid item xs={12} sm={12}>
                        <span style={styles.label}>B) Tổ hợp ưu tiên</span>
                    </Grid>
                    {useCategory &&
                        <>
                            <FormControl fullWidth>
                                <span>Tổ hợp môn học lớp 10*</span>
                                <Select
                                    labelId={"mon-4"}
                                    id={"ban-hoc-select"}
                                    value={selectedCategory.id}
                                    label={false}
                                    onChange={(e) => handleChangeCategory(e)}
                                >
                                    {categories.map((el, index) => (
                                        <MenuItem value={el.id}>{el.name}</MenuItem>
                                    ))
                                    }
                                </Select>
                            </FormControl>
                            {selectedCategory && selectedCategory.id && selectedElectives.map((item, index) => (
                                <Grid item xs={12} sm={6}>
                                    {item.forced ?
                                        <span>{'Môn tự chọn ' + (index + 1) + ': ' + item.name}</span>
                                        :
                                        <FormControl fullWidth>
                                            <span>{'Môn tự chọn ' + (index + 1) + "*"}</span>
                                            <Select
                                                id={"mon-tu-chon-select" + index}
                                                value={item.admissionSubjectId}
                                                label={false}
                                                onChange={(e) => handleChangeElective(e, index)}
                                            >
                                                {electives.map((el, index) => (
                                                    <MenuItem value={el.id}>{el.name}</MenuItem>
                                                ))
                                                }
                                            </Select>
                                        </FormControl>
                                    }
                                </Grid>
                            ))
                            }
                        </>
                    }

                </React.Fragment>
            }
            {tabIndex === 1 &&
                <React.Fragment>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <span
                                    style={styles.label}>{props.translate(`resources.admissions.fields.studentInfo`)}</span>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="customerName" label="resources.admissions.fields.customerName"
                                           disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <GenderInput source="gender" disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="dob" label="resources.admissions.fields.dob" disabled/>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextInput source="documentNumber" label="resources.admissions.fields.documentNumber"
                                           validate={maxLength(15, 'Không quá 15 ký tự')} disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <DateInput source="documentIssueDate"
                                           label="resources.admissions.fields.documentIssueDate"
                                           onChange={(e, v) => props.onDirectChange('documentIssueDate', v)}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="documentOrigin" label="resources.admissions.fields.documentOrigin"
                                           onChange={props.onChange('documentOrigin')}
                                           validate={maxLength(25, 'Không quá 25 ký tự')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <NationTypeInput source="nation" label="resources.admissions.fields.nation" required
                                                 validate={requiredField}
                                                 onChange={(e, v) => props.onDirectChange('nation', v)}
                                                 style={styles.width90}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <NationalityTypeInput source="nationality"
                                                      label="resources.admissions.fields.nationality"
                                                      validate={requiredField}
                                                      onChange={(e, v) => props.onDirectChange('nationality', v)}
                                                      style={styles.width90}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <ReligionTypeInput source="religion" label="resources.admissions.fields.religion"
                                                   validate={requiredField}
                                                   onChange={(e, v) => props.onDirectChange('religion', v)}
                                                   style={styles.width90}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="customerPhone" label="resources.admissions.fields.customerPhone"
                                           onChange={props.onChange('customerPhone')} style={styles.width90}
                                           maxLength={10}
                                           required
                                           validate={requiredPhone}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <AddressGdtxHybrid onChange={props.onChange} onDirectChange={props.onDirectChange}
                             prefixField='noiSinh' inputField={false}/>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="pobHospital" label="Nơi sinh (bệnh viện)"
                                   onChange={props.onChange('pobHospital')} style={styles.width90}
                                   validate={requiredField}/>
                    </Grid>
                    <AddressGdtxHybrid onChange={props.onChange} onDirectChange={props.onDirectChange}
                             prefixField='hometown'/>
                    <AddressGdtxHybrid onChange={props.onChange} onDirectChange={props.onDirectChange}
                             prefixField='permanentAddress'/>
                    <AddressGdtxHybrid onChange={props.onChange} onDirectChange={props.onDirectChange}
                             prefixField='temporaryAddress'/>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <span
                                    style={styles.label}>{props.translate(`resources.admissions.fields.fatherInfo`)}</span>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <BooleanInput source="haveFatherInfo" label="Có thông tin Cha"
                                              onChange={(e, v) => props.onDirectChange('haveFatherInfo', getBooleanValue(e, v))}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="fatherName" label="resources.admissions.fields.fatherName"
                                           onChange={props.onChange('fatherName')} style={styles.width90}
                                           validate={requiredMax50If('haveFatherInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="fatherPhone" label="resources.admissions.fields.fatherPhone"
                                           onChange={props.onChange('fatherPhone')} style={styles.width90}
                                           validate={optionalPhone}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="fatherIdentifierNumber"
                                           label="resources.admissions.fields.fatherIdentifierNumber"
                                           onChange={props.onChange('fatherIdentifierNumber')} style={styles.width90}
                                           validate={requiredIdentifierIf('haveFatherInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="fatherDob" label="resources.admissions.fields.fatherDob"
                                           onChange={props.onChange('fatherDob')} style={styles.width90}
                                           validate={requiredYobIf('haveFatherInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="fatherJob" label="resources.admissions.fields.fatherJob"
                                           onChange={props.onChange('fatherJob')} style={styles.width90}
                                           validate={requiredMax50If('haveFatherInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="fatherCompany" label="resources.admissions.fields.fatherCompany"
                                           onChange={props.onChange('fatherCompany')} style={styles.width90}
                                           validate={requiredMax50If('haveFatherInfo')}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid container xs={12}>
                                <span
                                    style={styles.label}>{props.translate(`resources.admissions.fields.motherInfo`)}</span>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <BooleanInput source="haveMotherInfo" label="Có thông tin Mẹ"
                                              onChange={(e, v) => props.onDirectChange('haveMotherInfo', getBooleanValue(e, v))}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="motherName" label="resources.admissions.fields.motherName"
                                           onChange={props.onChange('motherName')} style={styles.width90}
                                           validate={requiredMax50If('haveMotherInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="motherPhone" label="resources.admissions.fields.motherPhone"
                                           onChange={props.onChange('motherPhone')} style={styles.width90}
                                           validate={optionalPhone}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="motherIdentifierNumber"
                                           label="resources.admissions.fields.motherIdentifierNumber"
                                           onChange={props.onChange('motherIdentifierNumber')} style={styles.width90}
                                           validate={requiredIdentifierIf('haveMotherInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="motherDob" label="resources.admissions.fields.motherDob"
                                           onChange={props.onChange('motherDob')} style={styles.width90}
                                           validate={requiredYobIf('haveMotherInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="motherJob" label="resources.admissions.fields.motherJob"
                                           onChange={props.onChange('motherJob')} style={styles.width90}
                                           validate={requiredMax50If('haveMotherInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="motherCompany" label="resources.admissions.fields.motherCompany"
                                           onChange={props.onChange('motherCompany')} style={styles.width90}
                                           validate={requiredMax50If('haveMotherInfo')}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <span
                                    style={styles.label}>{props.translate(`resources.admissions.fields.guardianInfo`)}</span>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <BooleanInput source="haveGuardianInfo" label="Có thông tin Giám hộ"
                                              onChange={(e, v) => props.onDirectChange('haveGuardianInfo', getBooleanValue(e, v))}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianName" label="resources.admissions.fields.guardianName"
                                           onChange={props.onChange('guardianName')} style={styles.width90}
                                           validate={requiredMax50If('haveGuardianInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianPhone" label="resources.admissions.fields.guardianPhone"
                                           onChange={props.onChange('guardianPhone')} style={styles.width90}
                                           validate={optionalPhone}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianIdentifierNumber"
                                           label="resources.admissions.fields.guardianIdentifierNumber"
                                           onChange={props.onChange('guardianIdentifierNumber')} style={styles.width90}
                                           validate={requiredIdentifierIf('haveGuardianInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianDob" label="resources.admissions.fields.guardianDob"
                                           onChange={props.onChange('guardianDob')} style={styles.width90}
                                           validate={requiredYobIf('haveGuardianInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianJob" label="resources.admissions.fields.guardianJob"
                                           onChange={props.onChange('guardianJob')} style={styles.width90}
                                           validate={requiredMax50If('haveGuardianInfo')}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianCompany" label="resources.admissions.fields.guardianCompany"
                                           onChange={props.onChange('guardianCompany')} style={styles.width90}
                                           validate={requiredMax50If('haveGuardianInfo')}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <span style={styles.label}>Thông tin khác</span>
                    </Grid>

                    <FormDataConsumer>
                        {({formData}) => (
                            <Grid item xs={12} sm={4}>
                                <SelectInput source="primaryPhone" label="SĐT chính"
                                             choices={toPhoneChoices(formData)}
                                             onChange={(e, v) => props.onDirectChange('primaryPhone', v)}
                                             style={styles.width90}
                                             validate={requiredField}/>
                            </Grid>
                        )}
                    </FormDataConsumer>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="baseInsuranceNumber" label="Số thẻ BHYT (học sinh)"
                                   onChange={props.onChange('baseInsuranceNumber')} style={styles.width90}
                                   validate={[requiredField, maxLength(20, 'Không quá 20 ký tự')]}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <SelectInput source="doiTuongUuTien" label="Đối tượng ưu tiên"
                                     choices={DOI_TUONG_UU_TIEN_CHOICES}
                                     onChange={(e, v) => props.onDirectChange('doiTuongUuTien', v)}
                                     style={styles.width90}
                                     validate={requiredField}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <span style={styles.label}>Đã xong lớp 9</span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="oldSchoolYear" label="resources.admissions.fields.oldSchoolYear"
                                   onChange={props.onChange('oldSchoolYear')} style={styles.width90}
                                   validate={requiredMax50}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="oldSchoolName" label="resources.admissions.fields.oldSchoolName"
                                   onChange={props.onChange('oldSchoolName')} style={styles.width90}
                                   validate={requiredMax50}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="oldSchoolCity" label="resources.admissions.fields.oldSchoolCity"
                                   onChange={props.onChange('oldSchoolCity')} style={styles.width90}
                                   validate={requiredMax50}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="hocLuc" label="resources.admissions.fields.hocLuc"
                                   onChange={props.onChange('hocLuc')} style={styles.width90}
                                   validate={requiredMax50}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="hanhKiem" label="resources.admissions.fields.hanhKiem"
                                   onChange={props.onChange('hanhKiem')} style={styles.width90}
                                   validate={requiredMax50}/>
                    </Grid>

                </React.Fragment>
            }

            <Grid item xs={12} sm={12} style={{marginTop: 15}}>
                {defaultValue.active &&
                    <Button variant="contained"
                            color="primary"
                            style={styles.button}
                            disabled={defaultValue.saveDisabled}
                            onClick={save}>
                        <SaveIcon/> Lưu
                    </Button>
                }
                <Button variant="contained" style={styles.cancelBtn}
                        onClick={cancel}>
                    <CancelIcon/> Hủy
                </Button>
            </Grid>
        </React.Fragment>
    )
}

export default compose(translate, connect(null, {
    showNotification
}), withStyles(styles))(AdmissionFieldsGdtxHybrid)
